// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ThemeProvider } from '@mui/material/styles';
import theme from './theme';

import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://app.posthog.com',

  autocapture: true,
  capture_pageview: true,

  disable_session_recording: process.env.NODE_ENV === 'development',

  session_recording: {
    maskAllInputs: false,
  },

});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ThemeProvider theme={theme}>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </ThemeProvider>
);